// Stable empty values for `query.data ?? EMPTY_ARRAY`: a new `[]` on every render makes
// every useMemo / useCallback that depends on it run again (and its children re-render).
// Frozen, so code that sorts or pushes in place fails loudly instead of sharing the change.
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
